import React from 'react'
import { useCollection } from '@morningtrain/react-resources'
import { observer } from 'mobx-react'
import { format } from '@morningtrain/helpers'

function TotalAverage ({ totalName, dividerName, minDecimals = 2, maxDecimals = 2 }) {
  const collection = useCollection()

  if (collection.length === 0) {
    return 0
  }

  const totalCount = collection.reduce((total, value) => {
    return total + value[totalName]
  }, 0)

  const dividedBy = collection.reduce((total, value,) => {
    return total + value[dividerName]
  }, 0)

  return format.numberFormat(totalCount / dividedBy, maxDecimals, Math.min(maxDecimals, minDecimals))
}

export default observer(TotalAverage)
